//Dependencies
import React from 'react';

const HelpContent = () => {
  return (
    <div className='flex flex-col items-center justify-start gap-10 w-full'>
      <div className='flex flex-col items-start justify-center p-6 sm:p-8 md:p-10 rounded-sm shadow-sm border border-[#DCDCDC] border-b-[#06BD60] border-b-2 w-full max-w-md sm:max-w-lg md:max-w-3/5' id='accountInfoContainer'>
        <div className='flex flex-col items-start mb-10 w-full'>
          <div className='bg-[#06BD60] p-2 mb-4 rounded-sm'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-help-circle">
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
          <h2 className='text-3xl sm:text-4xl font-semibold mb-4 text-center sm:text-left'>
            Oh no you've dropped a clanger
          </h2>
          <h2 className='text-3xl sm:text-4xl font-semibold mb-4 text-center sm:text-left'>
            If you need help please contact your manager
          </h2>
          <h4 className='text-base sm:text-lg font-normal text-center sm:text-left'>
            Alternatively please try turning your computer off and on again or give it a good kick & bash.
          </h4>
        </div>
      </div>
    </div>
  );
};

export default HelpContent;